module.exports = __webpack_public_path__ + "img/workingcondition.9621796c.svg";